import React, { useEffect, useState } from "react";
import Triangle from "../common/Triangle";
import Price from "../common/Price";
import clappingGif from "../../assets/clapping.gif";
import cheerupGif from "../../assets/cheerup.gif";

function TodaySales(props) {
  const [todayTotal, setTodayTotal] = useState(0);
  const [yesterdayTotal, setYesterdayTotal] = useState(0);
  const isPositive = todayTotal - yesterdayTotal >= 0;
  const figureSrc = isPositive ? clappingGif : cheerupGif;
  useEffect(() => {
    try {
      setTodayTotal(props.value[props.page]["today"]);
      setYesterdayTotal(props.value[props.page]["yesterday"]);
    } catch (error) {}
  }, [props.page]);
  return (
    <div className="block w-[100%] px-[5%] py-10 border border-[#f3f4f6] font-semibold text-[5.7vw]">
      <div className="flex flex-col w-full">
        <div className="flex flex-col items-center text-[3.5vw] pb-6 font-bold truncate">
          <p
            className="inline-block rounded-[16px] bg-black px-[4vw] py-[1vw] text-neutral-200"
            id="store-name"
          >
            {sessionStorage.getItem("name")}
          </p>
        </div>
        <div id="todaysales" className="font-semibold">
          <div className="flex flex-col gap-0">
            {props.page === "daily"
              ? props.t(`todaySales.title.daily`)
              : props.page === "weekly"
              ? props.t("todaySales.title.weekly")
              : props.page === "monthly"
              ? props.t("todaySales.title.monthly")
              : ""}
            <Price
              value={todayTotal}
              underline={true}
              unit={props.t("todaySales.unit")}
              style={800}
            ></Price>

            <div>
              {props.t("todaySales.recorded")}{" "}
              {todayTotal - yesterdayTotal >= 0 ? "🥳" : ""}
            </div>
          </div>
        </div>
      </div>
      <div className="flex w-full items-center justify-center pb-2">
        <img
          src={figureSrc}
          alt={isPositive ? "축하" : "힘내세요"}
          className="h-[180px] w-[180px] object-contain"
        />
      </div>
      <div className="flex flex-col ">
        <div className="flex items-center justify-between">
          <div
            className="today-cmp__date"
            id="yesterday"
            style={{
              width: props.i18n.language == "en" ? "1200px" : "",
              backgroundColor: "#92A7DC",
              color: "white",
            }}
          >
            {
              props.page === "daily"
                ? props.t("todaySales.yesterday")
                : props.page === "weekly"
                ? props.t("todaySales.lastWeek")
                : props.page === "monthly"
                ? props.t("todaySales.lastMonth")
                : props.t("todaySales.yesterday") // 기본값
            }
          </div>
          <div className="today-cmp__arrow" style={{ width: "22%" }}></div>
          <div
            className="today-cmp__date"
            id="today"
            style={{
              width: props.i18n.language == "en" ? "1200px" : "",
              backgroundColor: "#2476D6",
              color: "white",
            }}
          >
            {
              props.page === "daily"
                ? props.t("todaySales.today")
                : props.page === "weekly"
                ? props.t("todaySales.thisWeek")
                : props.page === "monthly"
                ? props.t("todaySales.thisMonth")
                : props.t("todaySales.today") // 기본값
            }
          </div>
        </div>
        <div className="today-cmp__sales-div">
          <div className="today-cmp__sales" id="yesterday">
            <div className="today-cmp__benefits" id="yesterday">
              <Price
                value={yesterdayTotal}
                unit={props.t("todaySales.unit")}
              ></Price>
            </div>
          </div>
          <div className="today-cmp__arrow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="#5f6368"
            >
              <path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z" />
            </svg>
          </div>
          <div className="today-cmp__sales" id="today">
            <div
              className="today-cmp__benefits"
              id="today"
              style={{
                color:
                  todayTotal > yesterdayTotal
                    ? "red"
                    : todayTotal === yesterdayTotal
                    ? "black"
                    : "blue",
              }}
            >
              <Price
                value={todayTotal}
                unit={props.t("todaySales.unit")}
              ></Price>
            </div>
          </div>
        </div>
      </div>
      <div className="today-diff">
        <Triangle
          diff={todayTotal - yesterdayTotal}
          unit={props.t("todaySales.unit")}
        ></Triangle>
      </div>
    </div>
  );
}

export default TodaySales;
